import moment from 'moment';
import 'moment/locale/ja';
import { useEffect, useRef, useState,useLayoutEffect } from "react";
import { connect, useStore } from "react-redux";
import { useHistory } from "react-router";
import useMedia from "use-media";
import { cancelReserve } from '../../../const';
import common from '../../../resources/js/common/common';
import { Button } from "../../atoms/button";
import { ModalClose } from "../../atoms/modalClose";
import './../../../resources_membership_hotel/css/popup/cancel_popup.css';

const MembershipCancelPopup = (props) => {
    const {
        state,
        membershipReserveComf,
        setMembershipReserveComf,
        membershipCancelReserveComf,
        onClickCloseCancelPopupWindow,
    } = props;

    const store = useStore();
    const isCrawl = store.getState().login.loginType === 'CRAWL';
    const crawlMember = store.getState().crawlMember;
    const importedFlg = !!state.importedFlg;

    /** CRAWL用ユーザー情報設定 */
    const userInfo = isCrawl && crawlMember ?
        {
            syainNo: crawlMember.syain_no,
            uketukeCd: crawlMember.uketuke_cd,
            uketukeBashoCd: crawlMember.uketukebasyo_cd,
        } : null;

    const useMediaFlag = useMedia({ maxWidth: '820px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    const popupRef = useRef(null);
    const [errorFlg, setErrorFlg] = useState(false);

    const history = useHistory();

    useEffect(() => {
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
    }, [useMediaFlag]);

    useLayoutEffect(() => {
        popupRef.current.scrollTop = 0;
    },[]);

    const onClose = () => {
        onClickCloseCancelPopupWindow();
        setErrorFlg(false);
    }

    // 予約キャンセル後処理
    const afterCancelReserve = (res) => {
        let data = res.data;
        if (data.resultCode == 0) {
            onClickCloseCancelPopupWindow();
            if (importedFlg) {
                history.push("/reserve/hotel/importedCancelComplete");
            } else {
                history.push("/reserve/hotel/cancelComplete");
            }
        } else {
            setErrorFlg(true);
        }
    }

    // 予約キャンセル
    const onClickCancel = () => {
        //キャンセルAPI利用
        let req = {
            keiyakuNo: membershipCancelReserveComf.keiyakuNo,
            yoyakuNo: membershipCancelReserveComf.yoyakuNo,
            userInfo,
        }
        common.doPost(cancelReserve, req, afterCancelReserve);
    }

    return (
        <div ref={popupRef} className={state.membershipReservationCancelPopup ? "cancelPopupShow" : "popupNone"} id="js-popup">
            <div className={isMobilePhone ? "cancelPopupContentSp" : "cancelPopupContent"}>
                <div className={isMobilePhone ? "cancelPopupSpHead" : "cancelPopupPcHead"}>
                    <ModalClose divStyle={"modalClose"} svgStyle={"modalSvg"} onClick={() => onClose()} />
                    <h4 className="cancelPopupHeadTitle" >予約キャンセル</h4>
                </div>
                <div style={{height:"67px"}}/>
                {errorFlg ?
                    <div className='cancelPopupBodyArea'>
                        予約のキャンセルに失敗しました。
                    </div>
                    :
                    <div className='cancelPopupBodyArea'>
                        予約のキャンセルを行いますか？
                    </div>
                }
                {errorFlg ?
                    <div className={isMobilePhone ? 'cancelPopupBtnAreaSp' : 'cancelPopupBtnArea'}>
                        <Button buttonText="OK" className={"cancelYesBtn"} onClick={onClose} />
                    </div>
                    :
                    <div className={isMobilePhone ? 'cancelPopupBtnAreaSp' : 'cancelPopupBtnArea'}>
                        <Button buttonText="はい" className={"cancelYesBtn"} onClick={onClickCancel} />
                        <Button buttonText="いいえ" className={"cancelNoBtn"} onClick={onClose} />
                    </div>
                }
            </div>
            <div className="blackBackground" id="js-black-bg"></div>
        </div >
    );
};


const mapStateToProps = (state) => {
    return {
        login: state.login,
        membershipReserveComf: state.membershipReserveComf,
        membershipCancelReserveComf: state.membershipCancelReserveComf
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setSearchResult: (item) => {
            dispatch({ type: "SEARCH_RESULT", payload: item })
        },
        setMembershipReserveComf: (item) => {
            dispatch({ type: "MEMBERSHIP_RESERVE_COMF", payload: { membershipReserveComf: item } })
        },
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(MembershipCancelPopup);
